import { formatPhone } from '@neke/core';

/** Человек в админке: показываем то, чем он вошёл. */
interface HasLogin {
  email: string | null;
  phone: string | null;
}

/**
 * Чем человек опознаётся на экране.
 *
 * Пришедший через Google опознаётся почтой, зарегистрировавшийся по номеру —
 * телефоном, и заполнена всегда ровно одна из колонок. Пока вход был один,
 * админка печатала `email` напрямую; после появления регистрации по телефону
 * это давало бы пустое место там, где раньше стоял единственный способ
 * опознать человека в списке.
 *
 * Прочерк на случай «нет ни того, ни другого» — не мёртвая ветка: колонки
 * обнуляемы по отдельности, и строка без обеих возможна хотя бы через
 * миграцию или ручную правку базы. Пустая строка в разметке выглядела бы
 * потерянной вёрсткой, а прочерк — отсутствующим значением.
 */
export function loginOf(person: HasLogin): string {
  if (person.email) return person.email;
  return person.phone ? formatPhone(person.phone) : '—';
}
